import { render, staticRenderFns } from "./PageHeaderSlot.vue?vue&type=template&id=1e9a8f60&scoped=true&"
import script from "./PageHeaderSlot.vue?vue&type=script&lang=ts&"
export * from "./PageHeaderSlot.vue?vue&type=script&lang=ts&"
import style0 from "./PageHeaderSlot.vue?vue&type=style&index=0&id=1e9a8f60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9a8f60",
  null
  
)

export default component.exports